module.exports = require('./helpers/bundle-url').getBundleURL('2CgdX') + "default-icon.94aec26c.svg";